import React, { useState } from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 28, readOnly = false, testid }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onMouseEnter={() => !readOnly && setHover(n)}
          onMouseLeave={() => !readOnly && setHover(0)}
          onClick={() => !readOnly && onChange && onChange(n)}
          className={`transition-transform duration-150 ${readOnly ? "cursor-default" : "hover:scale-110 cursor-pointer"}`}
          data-testid={testid ? `${testid}-star-${n}` : undefined}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
        >
          <Star
            size={size}
            strokeWidth={1.8}
            className="transition-colors duration-150"
            fill={n <= active ? "#F59E0B" : "transparent"}
            color={n <= active ? "#F59E0B" : "#CBD5E1"}
          />
        </button>
      ))}
    </div>
  );
}
